<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Toast</h1>
          <figure class="image">
            <img class="zoom-default" data-zoom-src="static/images/toast/toast-pääkuva-highres.jpg" src="static/images/toast/toast-pääkuva-highres.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">The extra low and wide modules of Toast sofa are designed for free hangout and relaxation.</p>
          <p>
            The name comes from the toast-like shape of the modules, with round edges and inviting appearance. Produced by Interface, Finland.
          </p>
          <br>
          <p>
            Photography: Martti Järvi
          </p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/toast/toast-02-highres.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/toast/toast-03-highres.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Toast.vue